<template>
  <div>
    <v-main>
      <v-container>
        <div v-if="shopId === 'U5dc171850a89e6ca4bf5041c8725fdfe'">
          <h4>รายละเอียดการเยี่ยมชมสำนักงาน</h4>
          -พวกเรา มูลนิธินิชิเร็นโชชู
          ขอต้อนรับสมาชิกเพื่อการเยี่ยมชมสถานที่จัดตั้งสำนักงานในอนาคต<br />
          -ในขณะนี้สำนักงานจะเปิดในทุก ๆ วันอังคาร, วันพฤหัส และวันเสาร์ เวลา
          14:00 – 16:00<br />
          -เฉพาะสมาชิกของเราเท่านั้น ที่สามารถเข้าร่วมกิจกรรมได้<br />
          -ผู้ที่ไม่ได้ทำการจองนัดหมายหรือผู้ติดตามของผู้ที่ทำการจอง
          จะไม่สามารถเข้าร่วมกิจกรรมได้<br />
          -หากเป็นผู้ที่มีความเสี่ยงสูง อาทิ สัมผัสหรือใกล้ชิดผู้ที่ติดเชื้อ
          COVID-19 จะไม่สามารถเข้าร่วมกิจกรรมได้<br />
          -กรุณาจองคิวนัดหมายล่วงหน้าอย่างน้อย 1 วัน หากไม่ได้จองล่วงหน้า
          ไม่สามารถกดจองกระทันหันในวันนั้นๆที่ต้องการเข้าร่วมกิจกรรมได้<br />
          -ใน 1 การนัดหมายจะมีสมาชิกเข้าร่วม 5 คนและจะมีเวลา 20 นาที<br />
          -เพื่อให้โอกาสกับสมาชิกท่านอื่น ๆ ได้อย่างทั่วถึง สมาชิก 1 คน
          สามารถจองนัดหมายได้เดือนละ 1 ครั้งเท่านั้น<br />
          -สำหรับสมาชิกที่ไม่สามารถจองผ่านระบบได้ด้วยตัวเอง
          สามารถให้สมาชิกท่านอื่นจองผ่านระบบเข้ามาแทนได้
          โดยใส่ชื่อและเบอร์โทรของผู้ที่ต้องการเข้าร่วมกิจกรรม
          แล้วส่งต่อรูปคิวอาร์โค้ดที่ได้รับจากการจองให้สมาชิกผู้ที่ต้องการเข้าร่วม<br />
          -เฉพาะสมาชิกที่มีอายุมากกว่า 70 ปีขึ้นไป
          สามารถเข้าร่วมกิจกรรมได้โดยไม่ต้องลงทะเบียน ในเวลา 15:30 ของวันอังคาร,
          วันพฤหัส และวันเสาร์<br />
          -สมาชิกที่อยู่ในกลุ่มผู้ที่มีความเสี่ยงสูงหากติดเชื้อโควิด 19 อาทิ
          เช่น ผู้ที่มีโรคประจำตัว ฯลฯ ขอแนะนำให้จองนัดหมายในช่วงเวลา 14:00 น.
          เพื่อลดความเสี่ยง<br />
          <br />
          <h4>รายละเอียดการเป็นอาสาสมัครดูแลสำนักงาน</h4>
          -สามารถเข้ามาดูแลสำนักงานได้ในวันธรรมดาหรือวันที่ทำการจองเข้ามา
          โดยระยะเวลาในการดูแลสำนักงานจะเริ่มตั้งแต่ 13:30 ถึง 16:30 <br />
          -สามารถใช้งานคอมพิวเตอร์ได้อย่างคล่องแคล่ว<br />
          -สามารถทำความสะอาด ดูแลความเรียบร้อยของสำนักงาน<br />
          <br /><br />
        </div>
        <template v-if="languageSelect === 0">
          <h4>{{ headerTextTh }}</h4>
          {{ shopNameTextTh }} (ต่อไปนี้เรียกว่า "เรา")
          เคารพสิทธิความเป็นส่วนตัวของ{{ customerTextTh }} (ต่อไปนี้เรียกว่า
          "ท่าน")
          และเพื่อให้เกิดความมั่นใจว่าท่านได้รับความคุ้มครองข้อมูลส่วนบุคคล
          จึงได้จัดทำนโยบายความเป็นส่วนตัวฉบับนี้ขึ้น
          เพื่อแจ้งให้ทราบถึงรายละเอียดที่เกี่ยวข้องกับการเก็บรวบรวม การใช้
          และการเปิดเผย (รวมเรียกว่า "การประมวลผล") รวมตลอดถึงการลบและทำลาย
          ข้อมูลส่วนบุคคลของท่านทั้งช่องทางออนไลน์ และช่องทางอื่น ๆ
          ตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด ดังนี้ <br /><br />
          <h4>1. วัตถุประสงค์การประมวลผลข้อมูลส่วนบุคคล</h4>
          1.1
          เพื่อใช้ในการดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญาหรือเพื่อปฏิบัติตามสัญญาซึ่งท่านเป็นคู่สัญญากับเรา
          เช่น เพื่อการเก็บคะแนน และ/หรือ บริการให้แก่ท่าน หรือปฏิบัติตามสัญญาใด
          ๆ ซึ่งท่านเป็นคู่สัญญา ซึ่งรวมถึง การจัดการบัญชีผู้ใช้ (Account)
          ของท่าน การจัดส่งสินค้า และดำเนินการใด ๆ เพื่อให้ท่านได้รับบริการ
          หรือตามที่ท่านได้ร้องขอ<br />
          1.2 เพื่อประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลอื่น<br />
          (1) เพื่อให้เราสามารถจัดการ พัฒนา และดำเนินการใด ๆ
          เพื่อให้สามารถดำเนินธุรกิจได้ การบริหารจัดการและพัฒนาสินค้า และ/หรือ
          บริการ (รวมถึงเว็บไซต์ และแอปพลิเคชัน) การตรวจสอบและป้องกันการฉ้อโกง
          หรืออาชญากรรมอื่น ๆ การจัดการความสัมพันธ์{{
            customerTextTh
          }}และผู้ที่อาจเป็น{{
            customerTextTh
          }}
          การบำรุงรักษาและการใช้ระบบไอที<br />
          (2) เพื่อประโยชน์ทางด้านความปลอดภัย เช่น
          จัดให้มีมาตรการรักษาความปลอดภัย ซึ่งรวมถึงข้อมูลส่วนบุคคลของท่านด้วย
          เช่น การเข้าสู่ระบบ เข้าเว็บไซต์หรือแอปพลิเคชัน<br />
          (3) เพื่อดำเนินการทางการตลาด และวิเคราะห์ข้อมูล (Marketing and Data
          Analysis) เช่น การแจ้งข่าวสารและสิทธิประโยชน์ ผ่านทางอีเมล เอสเอ็มเอส
          แอปพลิเคชัน โซเชียลมีเดีย โทรศัพท์ และไดเร็กเมล
          รวมถึงเพื่อประโยชน์ในการวิจัยทางการตลาด เช่น ทำแบบสอบถาม
          เข้าสัมภาษณ์<br />
          (4) เพื่อการใช้สิทธิเรียกร้องทางกฎหมาย<br />
          1.3 เพื่อให้สามารถปฏิบัติตามกฎหมาย เช่น
          การปฏิบัติตามบทบัญญัติของกฎหมาย กฏระเบียบ
          และคำสั่งของผู้ที่มีอำนาจตามกฎหมาย<br />
          1.4 กรณีที่ท่านให้ความยินยอมเราจะประมวลผลข้อมูลส่วนบุคคล<br />
          (1) เพื่อให้เรา บริษัทในกลุ่มของเรา และพันธมิตร
          ส่งข่าวสารและสิทธิประโยชน์ผ่านทางอีเมล เอสเอ็มเอส แอปพลิเคชัน
          โซเชียลมีเดีย โทรศัพท์ และไดเร็กเมล<br />
          (2) เพื่อให้เราดำเนินการจัดกิจกรรมนอกจากที่กล่าวมาข้างต้น
          โดยอาจเก็บข้อมูลส่วนบุคคลของท่านเพิ่มเติม
          โดยจะแจ้งให้ทราบและขอความยินยอมจากท่านใหม่เป็นคราว ๆ ไป<br />
          ทั้งนี้ ท่านสามารถศึกษารายละเอียดเกี่ยวกับความยินยอมได้ในข้อ 4<br />
          <br />
          <h4>2. ข้อมูลส่วนบุคคลที่เก็บรวบรวม</h4>
          2.1 เมื่อท่านจะใช้บริการ รวมทั้งการเข้าเป็นสมาชิกเว็บไซต์ แอปพลิเคชัน
          หรือบัตรสิทธิประโยชน์ต่าง ๆ เราจะเก็บรวบรวมข้อมูลส่วนบุคคล ดังนี้<br />
          (1) ข้อมูลส่วนตัว เช่น ชื่อ นามสกุล วันเกิด LINE ID
          ที่อยู่(เฉพาะกรณีที่ท่านแลกสินค้าและให้จัดส่งไปที่ที่อยู่ท่าน)<br />
          (2) ข้อมูลการติดต่อ เช่น เบอร์โทรศัพท์ ที่อยู่
          ช่องทางติดต่อในโซเชียลมีเดีย<br />
          (3) ข้อมูลเกี่ยวกับการใช้บริการต่างๆ บนแอปพลิเคชัน เช่น
          ประวัติการแลกของรางวัล ประวัติการร่วมกิจกรรม ประวัติการได้รับคะแนน<br />
          2.2 เมื่อท่านเข้าใช้บริการ หรือเข้าชมเว็บไซต์หรือแอปพลิเคชัน
          เราจะเก็บรวบรวมข้อมูลส่วนบุคคล ดังนี้<br />
          (1) ข้อมูลเกี่ยวกับการสมัครสมาชิก (Registration) เช่น เบอร์มือถือ
          วันเกิด เพศ LINE ID<br />
          (2) ข้อมูลเกี่ยวกับอุปกรณ์อิเล็กทรอนิกส์ที่ท่านใช้ เช่น IP Address<br />
          (3) ชนิดและเวอร์ชันของบราวเซอร์ที่ท่านใช้ รวมถึงชนิดและเวอร์ชันของ
          plug-in ของบราวเซอร์<br />
          (4) การตั้งค่าเขตเวลา (Time zone)<br />
          2.6 ในกรณีที่จำเป็น
          เราจะประมวลผลข้อมูลส่วนบุคคลชนิดพิเศษของท่านโดยได้รับความยินยอมโดยชัดแจ้งจากท่านหรือเพื่อวัตถุประสงค์อื่นตามที่กฎหมายกำหนดไว้เท่านั้น
          ทั้งนี้
          เราจะใช้ความพยายามอย่างดีที่สุดในการจัดให้มีมาตรการรักษาความปลอดภัยที่เพียงพอเพื่อปกป้องคุ้มครองข้อมูลส่วนบุคคลชนิดพิเศษของท่าน<br />
          <template v-if="shopId === shopNameData.officeOmbudsman">
            2.7 ข้อแนะนำในการส่งข้อมูลเพิ่มเติม
            ผู้ใช้บริการควรหลีกเลี่ยงการแนบเอกสาร/รูปภาพเพิ่มเติมที่มีข้อมูลส่วนบุคคล
            ข้อมูลเรื่องร้องเรียน และถูกต้องตามกฎหมาย<br />
          </template>
          <br />
          <h4>3. คุกกี้</h4>
          3.1 คุกกี้ คือ ข้อมูลคอมพิวเตอร์ขนาดเล็ก (text file) ที่จะถูกติดตั้ง
          หรือบันทึกลงบนคอมพิวเตอร์หรืออุปกรณ์อิเล็กทรอนิกส์ของท่านเมื่อท่านเข้าชมเว็บไซต์
          คุกกี้จะจดจำข้อมูลการใช้งานเว็บไซต์ของท่าน ทั้งนี้
          เราจะเรียกเทคโนโลยีอื่นที่ทำหน้าที่คล้ายคลึงกันว่าคุกกี้ด้วย<br />
          3.2 เว็บไซต์นี้ใช้คุกกี้ในการเก็บข้อมูลการใช้งาน
          เพื่อให้คุณได้รับประสบการณ์ที่ดี หากคุณใช้งานเว็บไซต์ต่อ
          เราถือว่าคุณยอมรับการใช้งานคุกกี้<br />
          <br />
          <h4>4. การขอความยินยอมและผลกระทบที่เป็นไปได้จากการถอนความยินยอม</h4>
          4.1
          ในกรณีที่เราเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลโดยอาศัยความยินยอมของท่าน
          ท่านมีสิทธิที่จะถอนความยินยอมของท่านที่ให้ไว้กับเราได้ตลอดเวลา
          ซึ่งการถอนความยินยอมนี้จะไม่ส่งผลกระทบต่อการเก็บรวบรวม ใช้ เปิดเผย
          หรือประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมไปแล้ว<br />
          4.2
          หากท่านถอนความยินยอมที่ได้ให้ไว้กับเราหรือปฏิเสธไม่ให้ข้อมูลบางอย่าง
          อาจส่งผลให้เราไม่สามารถดำเนินการเพื่อบรรลุวัตถุประสงค์บางส่วนหรือทั้งหมดตามที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้ได้<br />
          4.3 หากท่านมีอายุไม่ครบ 20 ปีบริบูรณ์
          ก่อนการให้ความยินยอมโปรดแจ้งรายละเอียดผู้ใช้อำนาจปกครองให้เราทราบเพื่อให้เราสามารถดำเนินการขอความยินยอมจากผู้ใช้อำนาจปกครองด้วย<br />
          <br />
          <h4>5. ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล</h4>
          5.1
          เราจะเก็บข้อมูลส่วนบุคคลของท่านในระยะเวลาที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ตามประเภทข้อมูลส่วนบุคคลแต่ละประเภท
          เว้นแต่กฎหมายจะอนุญาตให้มีระยะเวลาการเก็บรักษาที่นานขึ้น
          ในกรณีที่ไม่สามารถระบุระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคลได้ชัดเจน
          เราจะเก็บรักษาข้อมูลไว้ตามระยะเวลาที่อาจคาดหมายได้ตามมาตรฐานของการเก็บรวบรวม
          (เช่น อายุความตามกฎหมายทั่วไปสูงสุด 10 ปี)<br />
          5.2
          เราจัดให้มีระบบการตรวจสอบเพื่อดำเนินการลบหรือทำลายข้อมูลส่วนบุคคลเมื่อพ้นกำหนดระยะเวลาการเก็บรักษาหรือที่ไม่เกี่ยวข้องหรือเกินความจำเป็นตามวัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคลนั้น<br />
          5.3 กรณีที่เราใช้ข้อมูลส่วนบุคคลของท่านโดยขอความยินยอมจากท่าน
          เราจะประมวลผลข้อมูลส่วนบุคคลดังกล่าวจนกว่าท่านจะแจ้งขอยกเลิกความยินยอมและเราดำเนินการตามคำขอของท่านเสร็จสิ้นแล้ว
          อย่างไรก็ดี
          เราจะยังเก็บข้อมูลส่วนบุคคลของท่านเท่าที่จำเป็นสำหรับบันทึกเป็นประวัติว่าท่านเคยยกเลิกความยินยอม
          เพื่อให้ เราสามารถตอบสนองต่อคำขอของท่านในอนาคตได้<br />
          <br />
          <h4>6. การเปิดเผยข้อมูลส่วนบุคคลให้บุคคลอื่น</h4>
          6.1 เราเปิดเผยและแบ่งปันข้อมูลส่วนบุคคลของท่านกับ<br />
          (1) บุคคลและนิติบุคคลอื่นที่ไม่ได้เป็นบริษัทในกลุ่มของเรา
          ("บุคคลอื่น")
          เพื่อบรรลุวัตถุประสงค์การเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลตามที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้
          เช่น ผู้ให้บริการด้านการขนส่ง (เช่น ไปรษณีย์)
          ผู้ให้บริการภายนอกที่ให้บริการและทำหน้าที่ภายใต้การควบคุมของเรา เช่น
          ช่วยในการประมวลผลการทำรายการ ส่งโฆษณาสำหรับผลิตภัณฑ์และบริการของเรา
          หรือให้ความช่วยเหลือและบริการแก่ท่าน ผู้ให้บริการทางด้านเทคโนโลยี
          (เช่น ระบบคลาวด์ บริการส่ง SMS บริการ data analytics)
          ผู้ให้บริการจัดทำโปรแกรมและระบบไอทีต่าง ๆ
          และบุคคลอื่นที่จำเป็นเพื่อให้เราสามารถดำเนินธุรกิจและให้บริการแก่ท่าน
          รวมถึงดำเนินการใด ๆ
          ตามวัตถุประสงค์การเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลตามที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้<br />
          6.2
          เราจะกำหนดให้ผู้ที่ได้รับข้อมูลมีมาตรการปกป้องข้อมูลของท่านอย่างเหมาะสมและประมวลผลข้อมูลส่วนบุคคลดังกล่าวเท่าที่จำเป็นเท่านั้น
          และดำเนินการเพื่อป้องกันไม่ให้ใช้หรือเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจโดยมิชอบ<br />
          <br />
          <h4>7. มาตรการความปลอดภัยสำหรับข้อมูลส่วนบุคคล</h4>
          7.1
          ความปลอดภัยของข้อมูลส่วนบุคคลของท่านเป็นสิ่งสำคัญสำหรับเราและเราได้นำมาตรฐานความปลอดภัยทางเทคนิคและการบริหารที่เหมาะสมมาใช้เพื่อปกป้องข้อมูลส่วนบุคคลจากการสูญหาย
          การเข้าถึงการใช้หรือการเปิดเผยโดยไม่ได้รับอนุญาต การใช้งานในทางที่ผิด
          การดัดแปลงเปลี่ยนแปลง
          และการทำลายโดยใช้เทคโนโลยีและขั้นตอนการรักษาความปลอดภัย เช่น
          การเข้ารหัสและการจำกัดการเข้าถึง
          เพื่อให้มั่นใจว่าบุคคลที่ได้รับอนุญาตเท่านั้นที่เข้าถึงข้อมูลส่วนบุคคลของท่านและบุคคลเหล่านี้ได้รับการฝึกอบรมเกี่ยวกับความสำคัญของการปกป้องข้อมูลส่วนบุคคล<br />
          7.2 เราจัดให้มีมาตรการรักษาความปลอดภัยที่เหมาะสม เพื่อป้องกันการสูญหาย
          เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข
          เปิดเผยข้อมูลส่วนบุคคลจากผู้ที่ไม่มีสิทธิหรือหน้าที่ที่เกี่ยวข้องกับข้อมูลส่วนบุคคลนั้น
          และจะจัดให้มีการทบทวนมาตรการดังกล่าวเมื่อมีความจำเป็นหรือเมื่อเทคโนโลยีเปลี่ยนแปลงไปเพื่อให้มีประสิทธิภาพในการรักษาความปลอดภัยที่เหมาะสม<br />
          <br />
          <h4>8. สิทธิเกี่ยวกับข้อมูลส่วนบุคคลของท่าน</h4>
          8.1 ท่านมีสิทธิตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล สรุปดังนี้<br />
          (1) ถอนความยินยอมที่ท่านได้ให้ไว้กับเรา
          เพื่อประมวลผลข้อมูลส่วนบุคคลของท่าน<br />
          (2) ขอดูและคัดลอกข้อมูลส่วนบุคคลของท่าน
          หรือขอให้เปิดเผยที่มาของข้อมูลส่วนบุคคลของท่าน<br />
          (3)
          ส่งหรือโอนข้อมูลส่วนบุคคลที่อยู่ในรูปแบบอิเล็กทรอนิกส์ตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนดไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น<br />
          (4) คัดค้านการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลที่เกี่ยวกับท่าน<br />
          (5) ลบหรือทำลาย
          หรือทำให้ข้อมูลส่วนบุคคลของท่านเป็นข้อมูลที่ไม่สามารถระบุตัวตนของท่านได้
          (anonymous)<br />
          (6) ระงับการใช้ข้อมูลส่วนบุคคลของท่าน<br />
          (7) แก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง เป็นปัจจุบัน สมบูรณ์
          และไม่ก่อให้เกิดความเข้าใจผิด<br />
          <br />
          <template v-if="shopId !== 'SD_1782983806478'">
            <h4>
              9.
              ข้อมูลเกี่ยวกับผู้ควบคุมข้อมูลส่วนบุคคลและเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
            </h4>
            9.1 ผู้ควบคุมข้อมูลส่วนบุคคล:
            <span v-if="shopId === 'SD_1725510922456'"
              >บริษัท บิวตี้โปรพลัส จำกัด สำนักงานใหญ่ ตั้งอยู่เลขที่88/1 ชั้น1
              ห้องเลขที่L209 ซอยสุขุมวิท55(ทองหล่อ) แขวงคลองตันเหนือ เขตวัฒนา
              กรุงเทพมหานคร 10110</span
            >
            <span v-else>{{ shopNameTextTh }}</span>
            <br />
            9.2 กรณีที่ท่านมีข้อสอบถามเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล
            โปรดติดต่อเบอร์ {{ contactTelTextTh }} หรือ e-mail:
            {{ contactEmailTextTh }}
            <span v-if="shopId === 'SD_1725510922456'"
              >หรือช่องทางไลน์ id : @lashdaystudio</span
            ><br />
            <br />
            <span v-if="shopId === 'SD_1725510922456'">
              <h4>10. นโยบายการคืนเงิน</h4>
              ทางร้านจะไม่คืนเงินในทุกกรณี ยกเว้นแต่มีเหตุสุวิสัย เท่านั้น
              การพิจารณาของทางร้านถือเป็นที่สิ้นสุด <br /><br />
            </span>
          </template>
          <template v-else>
            <h4>9. รายละเอียดการติดต่อเรา</h4>
            หากท่านมีความประสงค์ที่จะใช้สิทธิของท่านที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่าน
            หรือหากท่านมีข้อสงสัยเกี่ยวกับข้อมูลส่วนบุคคลของท่านภายใต้นโยบายความเป็นส่วนตัวฉบับนี้
            โปรดติดต่อเราหรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเรา ที่
            <br />
            9.1. ชื่อบริษัท <br />
            <span>• บริษัท เซ็นทรัล เรสตอรองส์ กรุ๊ป จำกัด</span><br />
            <span
              >• 306 อาคารเซ็นทรัลสีลมทาวเวอร์ ชั้น 5, 6, 7, 8 ถนนสีลม
              แขวงสุริยวงศ์ เขตบางรัก กรุงเทพมหานคร</span
            ><br />
            <span>• CRG Call Center: หมายเลข 1312</span><br />
            9.2. เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล<br />
            <span>• เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล</span><br />
            <span
              >• ฝ่ายคุ้มครองข้อมูลส่วนบุคคล เซ็นทรัล กรุ๊ป เลขที่ 22 ซอยสมคิด
              ถนนเพลินจิต แขวงลุมพินี เขตปทุมวัน กรุงเทพมหานคร 10330</span
            ><br />
            <span>• อีเมล์ {{ contactEmailTextTh }}</span
            ><br />
          </template>

          กรณีที่มีการแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้
          เราจะประกาศนโยบายความเป็นส่วนตัวฉบับใหม่ผ่านทางเว็บไซต์นี้
          ซึ่งท่านควรเข้ามาตรวจสอบความเปลี่ยนแปลงนโยบายความเป็นส่วนตัวเป็นครั้งคราว
          โดยนโยบายความเป็นส่วนตัวฉบับใหม่จะมีผลบังคับใช้ทันทีในวันที่ประกาศ<br />
        </template>
        <template v-else>
          <h4>{{ headerTextEn }}</h4>
          {{ shopNameTextEn }} (hereinafter referred to as "we") respects the
          privacy rights of {{ customerTextEn }}. (hereinafter referred to as
          "you") and to ensure that your personal information is protected
          Therefore, this privacy policy has been prepared. To notify you of
          details related to collection, use and disclosure (collectively,
          "Processing"), including deletion and destruction. Your personal
          information through online channels and other channels as required by
          the Personal Data Protection Law as follows: <br /><br />

          <h4>1. Purpose of processing personal data</h4>

          1.1 For the execution of your request prior to entering into a
          contract or for the performance of a contract with which you are a
          party to us, for example for collecting points and/or providing
          services to you. or perform any contracts to which you are a party,
          including managing your account (Account), delivery of goods; and take
          any action to provide you with services or as you request<br />
          1.2 For our legitimate interests or that of others<br />
          (1) To enable us to manage, develop and take any action to enable
          business operations. Management and development of products and/or
          services (including the website and applications) fraud detection and
          prevention or other crimes, managing customer and prospective
          relationships Maintenance and use of IT systems<br />

          (2) for the benefit of safety such as providing security measures This
          includes your personal information, such as logging in. Access the
          website or application<br />

          (3) to carry out marketing activities and analysis of data (Marketing
          and Data Analysis) such as news and benefits notifications via email,
          SMS, applications, social media, telephone and direct mail, including
          for the benefit of market research, such as Take the questionnaire,
          take the interview<br />

          (4) For the exercise of legal claims<br />
          1.3 To be able to comply with the law, such as compliance with the
          provisions of the law, rules and orders of those with legal
          authority<br />
          1.4 In the event that you give your consent, we will process personal
          data<br />
          (1) To enable us, our group companies and partners to send news and
          benefits via email, SMS, applications, social media, phone calls and
          direct mail<br />
          (2) to allow us to carry out activities other than the aforementioned
          They may collect additional personal information about you. We will
          inform you and ask for your consent from time to time.<br />
          You can learn more about consent in Article 4<br />
          <br />

          <h4>2. Personal data collected</h4>
          2.1 When you use the service Including membership to websites,
          applications or privilege cards, we collect personal information as
          follows:<br />
          (1) Personal information such as name, surname, date of birth, LINE
          ID, address (only if you redeem the product and have it delivered to
          your address).<br />
          (2) Contact information such as telephone numbers, addresses, social
          media channels<br />
          (3) Information about the use of various services on applications such
          as redemption history Activity history History of earning points<br />
          2.2 When you use the service or visit a website or application We
          collect personal information as follows:<br />
          (1) Information about subscription (Registration) such as mobile
          number, date of birth, gender, LINE ID<br />
          (2) Information about the electronic devices you use, such as IP
          Address<br />
          (3) the type and version of the browser you use including the type and
          version of the browser plug-in<br />
          (4) Time zone setting<br />
          2.6 Where necessary We will only process your special personal data
          with your express consent or for other purposes as required by law.
          Sufficient to protect the protection of your special personal
          information<br />
          <template v-if="shopId === shopNameData.officeOmbudsman">
            2.7 Guidelines for Submitting Additional Information Users are
            advised to avoid attaching additional documents or images that
            contain personal data or complaint-related information, and to
            ensure that any information submitted complies with applicable
            laws.<br />
          </template>
          <br />
          <h4>3. Cookies</h4>
          3.1 Cookies are small computer data (text files) that will be
          installed. or save it to your computer or electronic device when you
          visit the website. Cookies remember information about your use of the
          website. Other technologies that perform similar functions are also
          referred to as cookies.<br />
          3.2 This website uses cookies to collect usage data. to give you a
          good experience If you continue to use the website We assume that you
          agree to the use of cookies<br />
          <br />
          <h4>4. Consent and possible consequences of withdrawal of consent</h4>
          4.1 Where we collect and process personal data with your consent You
          have the right to withdraw your consent to us at any time. This
          withdrawal of consent will not affect the collection, use, disclosure
          or processing of personal data for which you have given consent.<br />
          4.2 If you withdraw the consent you have given us or refuse to provide
          certain information It may result in us being unable to perform some
          or all of the purposes outlined in this Privacy Policy.<br />
          4.3 If you are under 20 years of age, before giving consent, please
          provide us with your parental consent details so that we can proceed
          with obtaining consent from the parent.<br />
          <br />
          <h4>5. Period of retention of personal data</h4>
          5.1 We will keep your personal data for the period necessary to
          fulfill the purposes for each type of personal data. Unless the law
          allows for a longer retention period. In the event that the retention
          period of personal data cannot be clearly specified We will retain
          information for a period that may be expected in accordance with the
          standard of collection (e.g. a general legal age of up to 10
          years).<br />
          5.2 We provide an audit system for the deletion or destruction of
          personal data when the retention period has expired or is unrelated to
          or beyond the necessity for the purpose for which personal data was
          collected.<br />
          5.3 In the event that we use your personal information with your
          consent We will process such personal data until you request a
          revocation of your consent and we have completed your request. consent
          so that we can respond to your requests in the future<br />
          <br />

          <h4>6. Disclosure of Personal Information to Others</h4>
          6.1 We disclose and share your personal data with<br />
          (1) Other individuals and legal entities that are not companies in our
          group ("Other Parties") to fulfill the purposes for which personal
          data is collected and processed as set out in this Privacy Policy,
          such as courier service providers (e.g. postal service), third party
          service providers providing services and performing functions within.
          under our control, for example to assist in the processing of
          transactions send advertisements for our products and services or
          providing assistance and services to you Technology service providers
          (e.g., cloud services, SMS services, data analytics services),
          programming and IT system providers, and other parties necessary to
          enable us to conduct our business and provide services to you.
          including taking any action for the purpose of collecting and
          processing personal data as specified in this Privacy Policy<br />
          6.2 We will require data recipients to take appropriate measures to
          protect your data and only process such personal data as necessary.
          and take steps to prevent unauthorized use or unauthorized disclosure
          of personal information<br />
          <br />
          <h4>7. Security measures for personal data</h4>
          7.1 The security of your personal data is important to us and we have
          implemented appropriate technical and administrative security
          standards to protect personal data from loss. Unauthorized access, use
          or disclosure. misuse alteration and destruction using security
          technologies and procedures such as encryption and restricted access.
          This ensures that only authorized individuals have access to your
          personal data and that these individuals are trained on the importance
          of protecting personal data.<br />
          7.2 We provide appropriate security measures. To prevent loss, access,
          use, change, correction, disclosure of personal data from those who do
          not have rights or obligations related to that personal data. and will
          review such measures as necessary or as technology changes in order to
          provide appropriate security effectiveness.<br />
          <br />
          <h4>8. Rights Regarding Your Personal Data</h4>
          8.1 You have rights under the Personal Data Protection Laws.
          Summarized as follows:<br />
          (1) Withdraw the consent you have given us. to process your personal
          data<br />
          (2) Request to view and copy your personal information or request to
          disclose the source of your personal information<br />
          (3) send or transfer personal data contained in electronic format as
          required by the Personal Data Protection Laws to other data
          controllers<br />
          (4) objection to the collection, use or disclosure of personal data
          about you<br />
          (5) delete or destroy or make your personal information
          non-identifiable (anonymous)<br />
          (6) Suspend the use of your personal information<br />
          (7) correct your personal information to be accurate, current,
          complete and not misleading<br />
          <br />
          <template v-if="shopId !== 'SD_1782983806478'">
            <h4>
              9. Information on data controllers and personal data protection
              officers
            </h4>
            9.1 Data Controller:
            <span v-if="shopId === 'SD_1725510922456'"
              >บริษัท บิวตี้โปรพลัส จำกัด สำนักงานใหญ่ ตั้งอยู่เลขที่88/1 ชั้น1
              ห้องเลขที่L209 ซอยสุขุมวิท55(ทองหล่อ) แขวงคลองตันเหนือ เขตวัฒนา
              กรุงเทพมหานคร 10110</span
            >
            <span v-else>{{ shopNameTextEn }}</span>
            <br />
            9.2 In case you have any inquiries about personal data protection
            please contact number {{ contactTelTextEn }} or e-mail:
            {{ contactEmailTextEn }}
            <span v-if="shopId === 'SD_1725510922456'">
              or LINE ID : @lashdaystudio</span
            ><br />
            <br />
            <span v-if="shopId === 'SD_1725510922456'">
              <h4>10. Refund Policy</h4>
              The store does not offer refunds under any circumstances, except
              in cases of force majeure. The store's decision is final.
              <br /><br />
            </span>
          </template>
          <template v-else>
            <h4>9. Contact Us</h4>
            If you wish to exercise your rights regarding your personal data, or if you have any questions concerning your personal data under this Privacy Policy, please contact us or our Data Protection Officer at:
            <br />
            9.1. Company Name <br />
            <span>• Central Restaurants Group Co., Ltd.</span><br />
            <span
              >• 306 Central Silom Tower, 5th, 6th, 7th, 8th Floor, Silom Road, Suriyawong, Bang Rak, Bangkok</span
            ><br />
            <span>• CRG Call Center: 1312</span><br />
            9.2. Data Protection Officer<br />
            <span>• Data Protection Officer</span><br />
            <span
              >• Data Protection Department, Central Group, No. 22 Soi Somkid, Phloen Chit Road, Lumphini, Pathum Wan, Bangkok 10330</span
            ><br />
            <span>• Email: {{ contactEmailTextEn }}</span
            ><br />
          </template>
          In case of any changes to this privacy policy We will announce a new
          privacy policy through this website. You should periodically check for
          changes to the privacy policy. The new privacy policy will be
          effective immediately on the date of announcement.<br />
        </template>
      </v-container>
    </v-main>
  </div>
</template>
<script>
export default {
  name: 'PrivacyNotice',
  props: ['shopId', 'shopname', 'contactTel', 'Email', 'languageSelect'],
  data () {
    return {}
  },
  computed: {
    contactTelTextTh () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return '02-141-9391'
      } else {
        return this.contactTel
      }
    },
    contactTelTextEn () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return '02-141-9391'
      } else {
        return this.contactTel
      }
    },
    contactEmailTextTh () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return 'Apichat@ombudsman.go.th'
      } else {
        return this.Email
      }
    },
    contactEmailTextEn () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return 'Apichat@ombudsman.go.th'
      } else {
        return this.Email
      }
    },
    shopNameTextTh () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return this.shopname
      } else {
        return 'บริษัท ' + this.shopname + ' จำกัด'
      }
    },
    shopNameTextEn () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return this.languageSelect === 0 ? this.shopname : 'Ombudsman'
      } else {
        return this.shopname + ' Co., Ltd.'
      }
    },
    headerTextTh () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return 'นโยบายความเป็นส่วนตัวสำหรับผู้ใช้บริการ'
      } else {
        return 'นโยบายความเป็นส่วนตัวสำหรับลูกค้า'
      }
    },
    headerTextEn () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return 'Privacy Policy for Users'
      } else {
        return 'Privacy Policy for Customers'
      }
    },
    customerTextTh () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return 'ผู้ใช้บริการ'
      } else {
        return 'ลูกค้า'
      }
    },
    customerTextEn () {
      if (this.shopId === this.shopNameData.officeOmbudsman) {
        return 'Users'
      } else {
        return 'Customer'
      }
    }
  },
  async mounted () {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Booking/PrivacyNotice.vue